import { connect } from 'react-redux'
import Listado from '../../components/page/Listado'

export default connect(null, null)(Listado)
